<template>
  <div>
    <div class="header">
      <h1 class="page-title">已取消的订单</h1>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <ul class="menuItems clearfix">
          <li @click="Allorder()">
            <a>全部订单</a>
          </li>
        </ul>
        <div class="block">
          <span>下单日期</span>
          <el-date-picker
            v-model="value2"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="date()"
          ></el-date-picker>
          <input type="text" v-model="keywords" placeholder="请输入您要搜索的内容" />
          <button class="searchBtn" @click="selectOrder()">搜索</button>
          <div class="sy-zongj">
            <i>总计</i>
            <span>
              总订单数:
              <b>{{countOrder}}</b>条
            </span>
            <span>
              总金额:
              <b>{{countMoney}}</b>元
            </span>
          </div>
        </div>
      </div>

      <div class="main">
        <table
          width="100%"
          cellpadding="0"
          cellspacing="0"
          style="table-layout:fixed;"
          class="orderTab"
        >
          <thead>
            <th width="80">订单号</th>
            <th width="100">产品名称</th>
            <th width="250">规格</th>
            <th width="300">文件名</th>
            <th width="70">产品金额</th>
            <th width="70">运费</th>
            <th width="70">包装费</th>
            <th width="50">优惠金额</th>
            <th width="80">应付金额</th>
            <th width="50">订单状态</th>
            <th width="60">物流方式</th>
            <th width="140">下单时间</th>
          </thead>
          <template v-if="JSON.stringify(orderListData) !='[]'">
            <tbody
              :class="[item.length==1?'':'orange']"
              v-for="(item,index) in orderListData"
              :key="index"
            >
              <!-- 未合包布局 -->
              <template v-if="item.length==1">
                <tr>
                  <td>{{item[0].order_no}}</td>
                  <td>{{item[0].product_name}}</td>
                  <td>{{item[0].title}}</td>
                  <td>{{item[0].file}}</td>
                  <td>{{item[0].goods_price}}</td>
                  <td>{{item[0].shipping_fee}}</td>
                  <td>{{item[0].packprice}}</td>
                  <td>0</td>
                  <td>
                    <template v-if="item[0].total_price">
                      {{item[0].total_price}}
                    </template>
                  <template v-else>
                    {{item[0].realy_price}}
                  </template>
                  </td>
                  <td>{{item[0].status_str}}</td>
                  <td>{{item[0].express_name}}</td>
                  <td>{{item[0].createtime|dateFormat}}</td>
                </tr>
              </template>
              <!-- 合包布局 -->
              <template v-else>
                <template v-for="(item1,index1) in item">
                  <tr v-if="index1==0">
                    <td :rowspan="item.length">{{item1.order_no}}</td>
                    <td>{{item1.product_name}}</td>
                    <td>{{item1.title}}</td>
                    <td>{{item1.file}}</td>
                    <td>{{item1.goods_price}}</td>
                    <td>{{item1.shipping_fee}}</td>
                    <td>0</td>
                    <td>{{item1.total_price.toFixed(2)}}</td>
                    <td>{{item1.status_str}}</td>
                    <td :rowspan="item.length">{{item1.express_name}}</td>
                    <td :rowspan="item.length">{{item1.createtime|dateFormat}}</td>
                  </tr>
                  <tr v-else>
                    <td>{{item1.product_name}}</td>
                    <td>{{item1.title}}</td>
                    <td>{{item1.file}}</td>
                    <td>{{item1.goods_price}}</td>
                    <td>{{item1.shipping_fee}}</td>
                    <td>0</td>
                    <td>{{item1.total_price}}</td>
                    <td>{{item1.status_str}}</td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
          <div class="zw" v-else>暂无数据</div>
        </table>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :total="pageCount"
        :hide-on-single-page="true"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      value2: '',
      //   订单状态列表
      orderStatusList: [],
      orderListData: [],
      token: window.localStorage.getItem('token'),
      page: 1,
      keywords: '',
      loading: true,
      pageCount: 1,
      status: 7,
      mindate: '',
      maxdate: '',
      countOrder: 0,
      countMoney: 0
    }
  },
  created() {
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryOrderList()
    this.getYue()
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    date() {
      if (this.value2 != null) {
        this.mindate = this.value2[0] + ' 00:00:00'
        this.maxdate = this.value2[1] + ' 23:59:59'
      } else {
        this.mindate = ''
        this.maxdate = ''
      }
    },
    indexMethod(index) {
      if (this.page == 1) {
        return index + 1
      }
      if (index + 1 == 10) {
        return this.page + '' + 0
      }
      return this.page - 1 + '' + (index + 1)
    },
    //   订单列表
    handleCurrentChange(val) {
      this.page = val
      this.queryOrderList()
    },
    Allorder() {
      this.value2 = ''
      this.keywords = ''
      this.mindate = ''
      this.maxdate = ''
      this.page = 1
      this.queryOrderList()
    },
    selectOrder(status) {
      this.status = 7
      this.page = 1
      this.queryOrderList(status)
    },
    async queryOrderList() {
      this.loading = true
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('status', this.status)
      param.append('keywords', this.keywords)
      param.append('page', this.page)
      param.append('mindate', this.mindate)
      param.append('maxdate', this.maxdate)
      param.append('all', '1')
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/order/index',
        data: param
      })

      this.loading = false
      if (res.code == 1) {
        this.orderListData = res.data.data
        this.pageCount = res.data.page_count * 10
        if (res.data.num_count) {
          this.countOrder = res.data.num_count
          this.countMoney = res.data.price_count.toFixed(2)
        } else {
          this.countOrder = 0
          this.countMoney = 0
        }
      }
    }
  },
  mounted() {
    $('.menuItems').on('click', 'li', function() {
      $(this)
        .children('a')
        .css({ color: '#a77c5a', 'border-left': '3px solid #a77c5a' })
    })
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.el-card {
  ul {
    li {
      float: left;
      padding: 0px 15px;
      margin-right: 30px;
      height: 30px;
      cursor: pointer;
      a {
        padding-left: 5px;
        display: block;
        height: 15px;
        line-height: 15px;
        border-left: 3px solid #ccc;
        transition: all 0.3s;
      }
      a:hover {
        border-left: 3px solid #a77c5a;
      }
    }
  }
  .block {
    position: relative;
    margin-top: 30px;
    span {
      margin-right: 10px;
      color: #666;
    }
    input {
      box-shadow: 0px 0px 1px 1px #eee;
      padding-left: 10px;
      margin-left: 30px;
      width: 220px;
      height: 30px;
    }
    .searchBtn {
      padding: 8px 20px;
      margin-top: 5px;
      margin-left: 15px;
      color: #fff;
      background: #a77c5a;
      border-radius: 3px;
    }
    .sy-zongj {
      position: absolute;
      top: 13px;
      left: 800px;
      font-size: 16px;
      b {
        color: #e83030;
      }
    }
  }
  .main {
    font-size: 12px;
    .cz {
      font-size: 12px !important;
      margin-left: 5px;
    }
    .orange {
      background-color: #f0fff0;
      border-bottom: 2px solid #a77c5a;
    }
    .orderTab {
      position: relative;
      min-height: 60px;
      th {
        padding: 10px 5px;
        background-color: #fafafa;
      }

      td {
        padding: 10px;
        text-align: center;
        border: 1px solid #eee;
        font-size: 12px;
        color: #666;
        word-break: break-all;
      }
      .zw {
        font-size: 18px;
        color: #666;
        text-align: center;
        position: absolute;
        top: 50px;
        right: 750px;
      }
    }
  }
  .el-pagination {
    margin: 40px 0 0 700px;
  }
}
</style>
